export const stickyColumns = [
  'controlNumber',
  'markNumber',
  'productType',
  'mixDesign1',
  'mix1SqFt',
  'mix1Volume'
];
